import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useCountryCode, useLanguageCode } from '../contexts/environment';
import { useKompis } from '../contexts/kompis';
import { getAppState } from '../store/app/selectors';
import { getStoreAvailabilities } from '../utils';
import { getIsAvailableInStore, getIsAvailableForZip } from '../utils/availability';
import { getZipAvailability } from '../utils/zip';
export const useAvailability = (vpc) => {
    const countryCode = useCountryCode();
    const languageCode = useLanguageCode();
    const { storeId, stores, zipCode, availability } = useSelector(getAppState);
    const { dexfAppSettings } = useKompis();
    const [isAvailableInStore, setIsAvailableInStore] = useState();
    const [isAvailableForZip, setIsAvailableForZip] = useState();
    useEffect(() => {
        if (vpc && storeId && availability[vpc] && stores.some(store => store.id === storeId)) {
            getStoreAvailabilities(availability[vpc], storeId, dexfAppSettings).then(result => {
                setIsAvailableInStore(getIsAvailableInStore(result));
            });
        }
    }, [availability, countryCode, languageCode, dexfAppSettings, storeId, stores, vpc]);
    useEffect(() => {
        if (vpc && zipCode && availability[vpc] && vpc) {
            getZipAvailability(zipCode, availability[vpc], dexfAppSettings).then(result => {
                setIsAvailableForZip(getIsAvailableForZip(result));
            });
        }
        else {
            setIsAvailableForZip(undefined);
        }
    }, [availability, countryCode, languageCode, dexfAppSettings, vpc, zipCode]);
    return { isAvailableForZip, isAvailableInStore };
};
//# sourceMappingURL=useAvailability.js.map